import React, {useEffect, useRef, useState} from 'react';
// import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import {AppState, Text, useWindowDimensions, View} from 'react-native';
import {useRoute} from '@react-navigation/native';
import {HeaderPayment} from '@components/organisms/headers';
// import { Loading } from '@components/organisms/loading';
import {GridTemplate} from '@components/templates';
import {styles} from './styles';
import {InfoBox} from './infoBox';
import {InCase} from './inCase';
import {Payment} from './payment';
import PaymentPageSdk from '@raiffeisen-ecom/payment-sdk';
import {Input} from "../../../components/atoms";
import {RulesModal} from "../../../components/modals";
import {usePayment} from "./usePayment";

// import AppMetrica from 'react-native-appmetrica';

export const Donate = () => {
    const {
        errorText,
        setErrorText,
        setEmail,
        email,
        onPressPaymentIos,
        hasUser,
        reset,
    } = usePayment();

    const {name, params} = useRoute();

    const scrollRef = useRef();
    const webRef = useRef(null);
    const appState = useRef(AppState.currentState);
    const {height, width} = useWindowDimensions();

    const [appStateVisible, setAppStateVisible] = useState(appState.current);
    const [isVisible, setVisible] = useState(false);
    const [isVisibleSuccess, setVisibleSuccess] = useState(false);
    const [isOnfocusVisibleSuccess, setOnfocusVisibleSuccess] = useState(false);
    const [isVisibleFail, setVisibleFail] = useState(false);
    const [runPressPayment, setRunPressPayment] = useState(false);
    const [visibleRules, setVisibleRules] = useState(false);

    //const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const isSmall = width < 1070;
        setIsMobile(isSmall);
    }, [width]);

    useEffect(() => {
        setError('');
        setErrorText('');
    }, [email]);

    useEffect(() => {
        const paymentPage = new PaymentPageSdk('287404-1559',/* {
             url: 'https://pay-test.raif.ru/pay'
         }*/);
        // const paymentPage = new PaymentPageSdk('MB0001504659');


        if (hasUser) {
            // alert("Email валиден! Идём платить!");
            // paymentPage.replace({amount: 10.00});
            paymentPage.replace({
                //"publicId": "MB0001504659",
                "orderId": "1",
                "amount": 1.00,
                "receipt": {
                    "receiptNumber": "1",
                    "customer": {
                        "email": email,
                    },
                    "items": [
                        {
                            "name": "Подписка DSML",
                            "price": 1,
                            "quantity": 1,
                            "paymentObject": "COMMODITY",
                            "paymentMode": "FULL_PREPAYMENT",
                            "amount": 1,
                            "vatType": "NONE"
                        }
                    ]
                }
            });
            /*paymentPage.openPopup({amount: 10.10})
                .then(function() {
                    // console.log("Спасибо");
                })
                .catch(function() {
                    // console.log("Неудача");
                });*/
            reset();
        }
    }, [hasUser]);

    /*useEffect(() => {
        const name = params?.redirectRoute?.name;
        ['Tests', 'Find', 'Favourites'].includes(name) && setRunPressPayment(true);
        //setTimeout(onPressPaymentWidget, 800);
    }, [params]);*/

    /*useEffect(() => {
        const subscription = AppState.addEventListener('change', (nextAppState) => {
            if (
                appState.current.match(/inactive|background/) &&
                nextAppState === 'active'
            ) {
                //console.log('App has come to the foreground!');
                if (visiblePaymentSuccessModal) setVisibleSuccess(true);
                setVisible(false);
            }

            appState.current = nextAppState;
            setAppStateVisible(appState.current);
            // console.log('AppState', appState.current);
        });

        return () => {
            subscription.remove();
        };
    }, [visiblePaymentSuccessModal]);*/

    const onPressPaymentWidget = () => {
        canPay();
    };

    const errors = {
        'user-not-found': 'пользователь не найден',
        'invalid-email': 'некорректный email',
        'network-request-failed': 'технические проблемы, попробуйте позже',
        'empty-email': 'Обязательное поле'
    };
    const EMAIL_REGEXP = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;

    function isEmailValid() {
        return EMAIL_REGEXP.test(email);
    }

    const canPay = (value) => {
        if (email === '') {
            setError(errors['empty-email']);
            return;
        }
        if (!isEmailValid()) {
            setError(errors['invalid-email']);
            return;
        }
        onPressPaymentIos();
    };

    return (
        <View style={{height: height}}>
            {/*<View style={styles.root}>*/}
            <HeaderPayment
                //displayName={'DSML'}
                style={styles.headerPayment}
                subtitle="Купить полный доступ"
                detail={
                    'Ко всем тестам с полным функционалом:\nвсе области тестирования, поиск по вопросам,\nтест по избранному, режим теста, режим экзамена.'
                }
                icon={true}
            />
            <RulesModal visible={visibleRules} onClose={() => setVisibleRules(false)} isMobile={isMobile}/>
            <GridTemplate style={styles.template}>
                <View style={{width: '100%', alignItems: 'center', justifyContent: 'center'}}>
                    <InfoBox
                        style={[{width: isMobile ? '100%' : '60%'}, styles.infoBox]}
                        title={'300₽ в месяц'}
                        detail={
                            'Вы покупаете полный доступ ко всем тестам с полным функционалом: все области тестирования, поиск по вопросам, тест по избранному, режим тестирования и экзамена'
                        }
                    />
                    <InCase isMobile={isMobile} style={{width: isMobile ? '100%' : '60%'}}/>
                    <View style={{
                        width: isMobile ? '100%' : '60%',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-around'
                    }}>
                        <img
                            src="https://optim.tildacdn.com/tild3036-6362-4361-a661-363336396330/-/resize/320x/-/format/webp/64c4b82d3c41071c2f08.png"
                            alt="альтернативный текст"
                            width={'15%'}
                        />

                        <img
                            src="https://optim.tildacdn.com/tild6364-3635-4430-a631-633532333130/-/resize/320x/-/format/webp/mastercard.png"
                            alt="альтернативный текст"
                            width={'15%'}
                        />
                        <img
                            src="https://optim.tildacdn.com/tild3331-3837-4166-a333-623535646433/-/resize/320x/-/format/webp/mir.png"
                            alt="альтернативный текст"
                            width={'15%'}
                        />
                    </View>
                </View>
                <View style={{width: isMobile ? '100%' : '60%', alignSelf: 'center', marginBottom: 15}}>
                    {/*<Text style={styles.titleDetail}>Вы можете обратиться за консультацией по вопросам оформления
                        подписки или возврата средств на электронный адрес: support@rentel.app</Text>*/}
                    <Text style={styles.titleEmail}>Введите email, это необходимо для создания заказа</Text>
                    <Input
                        customStyle={{width: '100%', alignSelf: 'center'}}
                        customStyleInput={!!error || !!errorText ? {borderColor: 'red', borderWidth: 2} : null}
                        value={email}
                        onChangeText={setEmail}
                        error={error || errorText}
                        placeholder="Эл. почта"
                        icon="email"
                        dataDetectorTypes="address"
                        keyboardType="email-address"
                        textContentType="emailAddress"
                    />
                </View>
                <Payment
                    style={{paddingBottom: 15, widh: '100%', alignItems: 'center'}}
                    onPressPayment={onPressPaymentWidget}
                    onPressRules={() => setVisibleRules(true)}
                    //isFetching={isFetching}
                    //disabled={isFetching}
                    isMobile={isMobile}
                />
            </GridTemplate>
            {/*</View>*/}
            {/*{isFetching && (
                <View style={styles.loadingContainer}>
                     <Loading size={50} color={colors.Green_Prom} style={styles.loading} />
                </View>
            )}
            <PaymentSuccess
                visible={visiblePaymentSuccessModal || isVisibleSuccess}
                isPaymentMethodSberbankExternal={isPaymentMethodSberbankExternal}
                closeModal={() => {
                    resetModal();
                    setVisibleSuccess(false);
                    setVisiblePaymentSuccessModal(false);
                    //setOnfocusVisibleSuccess(false);
                }}
                scrollRef={scrollRef}
            />
            <PaymentFail
                visible={visiblePaymentFailModal || isVisibleFail}
                isPaymentMethodSberbankExternal={isPaymentMethodSberbankExternal}
                closeModal={() => {
                    resetModal();
                    setVisiblePaymentFailModal(false);
                    setVisibleFail(false);
                }}
                scrollRef={scrollRef}
            />*/}

        </View>
    );
};
